import { Div, Label } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class FormRow extends Div
{
    constructor(label: string, input: appendable)
    {
        super("table-row");

        this.Append(
            new Label(label).Class("label-cell"),
            new Div().Append(input).Class("input-cell")
        );
    }
}
